/* jshint esversion: 6, -W097 */
/* globals require */
(function(angular) {
    'use strict';

    var app = angular.module('enervee');

    app.directive('globalAlerts', [
        function() {
            return {
                restrict: 'E',
                replace: true,
                template: require('@app/shared/globalAlerts/globalAlerts.html'),
            };
        }
    ]);
})(angular);